import { _, React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type BacktestNameCountProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params;
  setParams: (_p: DraftParams) => void;
  title: string;

  fullScreen?: boolean;
  context?: ts.types.backtest.BacktestAnaylsisContext | ts.types.basket.BasketAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'backtest_name_count', string>;
};

const BacktestNameCount = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  params,
  setParams,
  mode,
  fullScreen,
  context,
  title,
}: BacktestNameCountProps) => {
  const hasBenchmark = React.useMemo(
    () => (params.isBasket ? context?.definition?.optimizer_rebalance : !_.isEmpty(context?.definition?.benchmark)),
    []
  );

  const chart = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      params={params}
      widgetKey={widgetKey}
      fullScreen={fullScreen}
      loadWidgetData={loadWidgetData}
      portfolios={widgetPaths['backtest_name_count']}
      scale={ts.enums.SCALE_ENUM.LINEAR}
      isBasket={!!(context as ts.types.basket.BasketAnalysisContext).basket_id}
      isCombinedBasket={(context as ts.types.basket.BasketAnalysisContext).type == ts.enums.BASKET_TYPE_ENUM.COMBINED}
      isLongOnly={
        (context as ts.types.backtest.BacktestAnaylsisContext).ui_metadata?.longOption ==
        ts.enums.LONG_OPTION_ENUM.LONG_ONLY
      }
      hasBenchmark={hasBenchmark}
      title={title}
    />
  );

  return (
    <>{mode == 'edit' ? <Form params={params} setParams={setParams} hasBenchmark={hasBenchmark} /> : <>{chart()}</>}</>
  );
};

export default BacktestNameCount;
